import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAFAFA] to-[#F3F1EC] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <Logo size="md" />
        </div>
        
        <div className="mb-8">
          <h1 className="text-8xl font-display font-bold text-[#1A1C1E] mb-2">404</h1>
          <p className="text-2xl font-display font-semibold text-[#5C5F62]">Page not found</p>
        </div>

        <p className="text-[#8A8D91] mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={() => nav(-1)}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-[#E5E5E5] text-[#1A1C1E] font-medium hover:border-[#C86B53] hover:text-[#C86B53] transition"
          >
            <ArrowLeft className="h-4 w-4" /> Go back
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#C86B53] text-white font-medium hover:bg-[#B85A42] transition"
          >
            <Home className="h-4 w-4" /> Go home
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-[#E5E5E5]">
          <p className="text-xs text-[#8A8D91] mb-4">Quick links</p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link to="/login" className="text-xs text-[#5C5F62] hover:text-[#C86B53] transition">Login</Link>
            <span className="text-[#E5E5E5]">•</span>
            <Link to="/signup" className="text-xs text-[#5C5F62] hover:text-[#C86B53] transition">Sign up</Link>
            <span className="text-[#E5E5E5]">•</span>
            <Link to="/contact" className="text-xs text-[#5C5F62] hover:text-[#C86B53] transition">Contact</Link>
            <span className="text-[#E5E5E5]">•</span>
            <Link to="/products" className="text-xs text-[#5C5F62] hover:text-[#C86B53] transition">Products</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
